import { gql } from '@apollo/client'
import { CALENDAR_INJURIES_QUERY } from '../graphql'
import { FIELD_ID } from '../components/CustomCode/TKCal/tkcal_constants'
import { makeInteger } from '../utils'

const CALENDAR_INJURIES = gql(CALENDAR_INJURIES_QUERY)

const tkcal = {
  choice_hook: async function choice_hook(field, object, parentObjectId, allInputs) {
    console.log('tkcal.choice_hook', field, object, parentObjectId, allInputs)

    let choices = []
    switch (makeInteger(field.id)) {
      case FIELD_ID.calendarEvent.injury:
        let calendarId = null
        if (allInputs) {
          calendarId = allInputs[FIELD_ID.calendarEvent.calendar].currentValue.id
        }
        const results = await window.apolloClient.query({ query: CALENDAR_INJURIES, variables: { calendarId: calendarId } })
        console.log('tkcal.choice_hook: ', field.name, results)
        choices = results.data.calendarInjuries
        break
      default:
        console.log(`document_model.choice_hook field "${field.name}" not handled.`)
    }
    return choices
  }
}

export default tkcal
